import React, { useState } from 'react';
import Navigation from './components/Navigation';
import Footer from './components/Footer';
import Home from './pages/Home';
import Resonance from './pages/Resonance';
import Origins from './pages/Origins';
import Explore from './pages/Explore';

function App() {
  const [currentPage, setCurrentPage] = useState('home');

  const handleNavigate = (page) => {
    setCurrentPage(page);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const renderPage = () => {
    switch (currentPage) {
      case 'home':
        return <Home onNavigate={handleNavigate} />;
      case 'resonance':
        return <Resonance />;
      case 'origins':
        return <Origins />;
      case 'explore':
        return <Explore />;
      default:
        return <Home onNavigate={handleNavigate} />;
    }
  };

  return (
    <div className="min-h-screen bg-dark-slate flex flex-col">
      <Navigation currentPage={currentPage} onNavigate={handleNavigate} />
      <main className="pt-16 flex-1">
        {renderPage()}
      </main>
      <Footer />
    </div>
  );
}

export default App;
